import moment from 'moment';
import { twelveHourUserSettingForBrandedEmail, twelveHourUserSetting, twentyFourHourTimePadded } from '../../../constants/timezone-format';
import { DateService } from '../../../services/date-service';

const formatTime = (time, timeFormat) => DateService.extractTime(moment().utc().set(time).toDate(), timeFormat);

const buildTimeFromUnits = (tUnits, timeFormat) => {
  const formatToUse = timeFormat === twelveHourUserSetting ? twelveHourUserSettingForBrandedEmail : timeFormat;
  const time24HourPadded = formatTime(tUnits, twentyFourHourTimePadded);
  const timeActualValue = formatTime(tUnits, twelveHourUserSettingForBrandedEmail).toUpperCase();
  const timeDisplayValue = formatTime(tUnits, formatToUse).toUpperCase();
  return {
    time24HourPadded,
    value: timeActualValue,
    display: timeDisplayValue,
  };
};

export const getTimes = ({ allowPastTimes = true, endTime, minuteIncrementUnit, startTime, timeFormat }) => {
  const timeArray = [];
  for (let hour = startTime; hour < endTime; hour++) {
    const hoursTimeObject = buildTimeFromUnits(
      {
        hour,
        minute: 0,
        second: 0,
        millisecond: 0,
      },
      timeFormat,
    );
    timeArray.push(hoursTimeObject);
    if (minuteIncrementUnit) {
      for (let minute = minuteIncrementUnit; minute < 60; minute += minuteIncrementUnit) {
        const hoursAndMinutesTimeObject = buildTimeFromUnits(
          {
            hour,
            minute,
            second: 0,
            millisecond: 0,
          },
          timeFormat,
        );
        timeArray.push(hoursAndMinutesTimeObject);
      }
    }
  }
  if (!allowPastTimes) {
    const now = new Date();
    const { time24HourPadded: currentTime24HourPadded } = buildTimeFromUnits(
      {
        hour: now.getHours(),
        minute: now.getMinutes(),
        second: 0,
        millisecond: 0,
      },
      timeFormat,
    );
    return timeArray.filter(({ time24HourPadded }) => time24HourPadded >= currentTime24HourPadded);
  }
  return timeArray;
};
